'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash');

var _reactRedux = require('react-redux');

require('./SavingFeedbackUtil.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {
        lastAction: state.get('lastSaved')
    };
};

var SavingFeedbackUtil = (_dec = (0, _reactRedux.connect)(mapStateToProps), _dec(_class = function (_React$Component) {
    _inherits(SavingFeedbackUtil, _React$Component);

    function SavingFeedbackUtil(props) {
        _classCallCheck(this, SavingFeedbackUtil);

        var _this = _possibleConstructorReturn(this, (SavingFeedbackUtil.__proto__ || Object.getPrototypeOf(SavingFeedbackUtil)).call(this, props));

        _this.state = {
            showLoading: false,
            hidden: true
        };

        _this.stopSaving = (0, _lodash.debounce)(function () {
            _this.setState({ showLoading: false });
            _this.hide();
        }, 2000);

        _this.hide = (0, _lodash.debounce)(function () {
            _this.setState({ hidden: true });
        }, 4000);
        return _this;
    }

    _createClass(SavingFeedbackUtil, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.lastAction !== this.props.lastAction) {
                this.setState({ showLoading: true, hidden: false });
                this.stopSaving();
                this.hide.cancel();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.stopSaving.cancel();
            this.hide.cancel();
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                showLoading = _state.showLoading,
                hidden = _state.hidden;


            return _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)('SavingFeedbackUtil', { hidden: hidden }) },
                showLoading ? _react2.default.createElement(
                    'span',
                    { className: 'saving' },
                    'Saving...'
                ) : _react2.default.createElement(
                    'span',
                    { className: 'save' },
                    'Saved'
                )
            );
        }
    }]);

    return SavingFeedbackUtil;
}(_react2.default.Component)) || _class);
exports.default = SavingFeedbackUtil;


SavingFeedbackUtil.propTypes = {
    lastAction: _propTypes2.default.bool
};


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/SavingFeedbackUtil.js
// module id = 2166
// module chunks = 0